<template>
  <div class="page contact">
    <Header />

    <section class="hero section">
      <div class="hero-overlay section-container">
        <div class="map-card">
          <h2>{{ headInfo.departmentName }}</h2>
          <div class="light_line">
            <div class="line"></div>
            <div class="light"></div>
          </div>
          <div class="info_item location">
            <img src="../static/contact/location.png" alt="">
            <div class="detail">
              <div class="label">地址：</div>
              <div class="value">{{ headInfo.address }}</div>
            </div>
          </div>
          <div class="contact_methods">
            <div class="info_item">
              <img src="../static/contact/phone.png" alt="">
              <div class="detail">
                <div class="label">电话：</div>
                <div class="value">{{ headInfo.phone }}</div>
              </div>
            </div>
            <div class="divide_line"></div>
            <div class="info_item">
              <div class="tag"></div>
              <img src="../static/contact/email.png" alt="">
              <div class="detail">
                <div class="label">邮箱：</div>
                <div class="value">{{ headInfo.email }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div class="section navigation">
      <div class="section-container">
        首页 > 联系我们
      </div>
    </div>
    <section class="section">
      <div class="section-container maps-section">
        <div class="map-card map-card-mobile">
          <h2>{{ headInfo.departmentName }}</h2>
          <div class="light_line">
            <div class="line"></div>
            <div class="light"></div>
          </div>
          <div class="info_item location">
            <img src="../static/contact/location.png" alt="">
            <div class="detail">
              <div class="label">地址：</div>
              <div class="value">{{ headInfo.address }}</div>
            </div>
          </div>
          <div class="contact_methods">
            <div class="info_item">
              <img src="../static/contact/phone.png" alt="">
              <div class="detail">
                <div class="label">电话：</div>
                <div class="value">{{ headInfo.phone }}</div>
              </div>
            </div>
            <div class="divide_line"></div>
            <div class="info_item">
              <div class="tag"></div>
              <img src="../static/contact/email.png" alt="">
              <div class="detail">
                <div class="label">邮箱：</div>
                <div class="value">{{ headInfo.email }}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="map-card" v-for="(item, index) in list" :key="index" :class="{mini: !item.address}">
          <h2>{{ item.departmentName }}</h2>
          <div class="light_line">
            <div class="line"></div>
            <div class="light"></div>
          </div>
          <div class="info_item location" v-if="item.address">
            <img src="../static/contact/location.png" alt="">
            <div class="detail" >
              <div class="label">地址：</div>
              <div class="value">{{ item.address }}</div>
            </div>
          </div>
          <div class="contact_methods">
            <div class="info_item">
              <img src="../static/contact/phone.png" alt="">
              <div class="detail">
                <div class="label">电话：</div>
                <div class="value">{{ item.phone }}</div>
              </div>
            </div>
            <div class="divide_line"></div>
            <div class="info_item">
              <div class="tag"></div>
              <img src="../static/contact/email.png" alt="">
              <div class="detail">
                <div class="label">邮箱：</div>
                <div class="value">{{ item.email }}</div>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="map-card">
          <h2>深圳星翰</h2>
          <div class="light_line">
            <div class="line"></div>
            <div class="light"></div>
          </div>
          <div class="info_item location">
            <img src="../static/contact/location.png" alt="">
            <div class="detail">
              <div class="label">地址：</div>
              <div class="value">深圳市宝安区石环路202号创富科技园D栋综合楼</div>
            </div>
          </div>
          <div class="contact_methods">
            <div class="info_item">
              <img src="../static/contact/phone.png" alt="">
              <div class="detail">
                <div class="label">电话：</div>
                <div class="value">0512-6339 0858</div>
              </div>
            </div>
            <div class="divide_line"></div>
            <div class="info_item">
              <div class="tag"></div>
              <img src="../static/contact/email.png" alt="">
              <div class="detail">
                <div class="label">邮箱：</div>
                <div class="value">Marketing@xinghanmaterials.com</div>
              </div>
            </div>
          </div>
        </div>

        <div class="map-card mini">
          <h2>营销中心</h2>
          <div class="light_line">
            <div class="line"></div>
            <div class="light"></div>
          </div>
          <div class="contact_methods">
            <div class="info_item">
              <img src="../static/contact/phone.png" alt="">
              <div class="detail">
                <div class="label">电话：</div>
                <div class="value">13603718021</div>
              </div>
            </div>
            <div class="divide_line"></div>
            <div class="info_item">
              <div class="tag"></div>
              <img src="../static/contact/email.png" alt="">
              <div class="detail">
                <div class="label">邮箱：</div>
                <div class="value">Sales@xinghanmaterials.com</div>
              </div>
            </div>
          </div>
        </div>


        <div class="map-card mini">
          <h2>人力资源中心</h2>
          <div class="light_line">
            <div class="line"></div>
            <div class="light"></div>
          </div>
          <div class="contact_methods">
            <div class="info_item">
              <img src="../static/contact/phone.png" alt="">
              <div class="detail">
                <div class="label">电话：</div>
                <div class="value">13033721220</div>
              </div>
            </div>
            <div class="divide_line"></div>
            <div class="info_item">
              <div class="tag"></div>
              <img src="../static/contact/email.png" alt="">
              <div class="detail">
                <div class="label">邮箱：</div>
                <div class="value">Hr@xinghanmaterials.com</div>
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </section>


    <Footer />
  </div>
</template>

<script>
import Header from '../components/Header.vue'
import Footer from '../components/Footer.vue'
import { ContactUsAPI } from '../api/api.js'

export default {
  name: 'Contact',
  components: { Header, Footer },
  data() {
    return {
      headInfo: {},
      list: [],
    }
  },
  mounted() {
    // 顶部的联系我们
    ContactUsAPI.getHeadquarters().then(res => {
      console.log('headquarter', res);
      this.headInfo = res;
    })

    // 列表
    ContactUsAPI.getAllContacts().then(res => {
      console.log('list', res);
      this.list = (res || []).filter((item)=>{return item.isHeadquarters !== 1});
    })
  },
  methods: {

  }
}
</script>

<style lang="less" scoped>
// pc
@media (min-width: 751px) {
  .hero {
    height: 800px;
    background: url('../static/contact/head_bg.png') center/cover no-repeat;

    .hero-overlay {
      .map-card {
        position: relative;
        line-height: 1;
        top: 232px;
        bottom: 150px;
        box-sizing: border-box;
        width: 686px;
        height: 418px;
        padding: 70px 60px 36px;
        background: #fff;

        h2 {
          margin-bottom: 42px;
          font-weight: 600;
          font-size: 40px;
          color: #363636;
        }

        .light_line {
          position: relative;

          .line {
            width: 100%;
            height: 1px;
            background: #e5e5e5;
          }

          .light {
            position: absolute;
            left: 0;
            top: 0;
            width: 24px;
            height: 3px;
            background: #0248FF;
          }
        }

        .info_item {
          display: flex;
          align-items: flex-start;
          padding: 34px 0;

          img {
            margin-right: 17px;
          }

          .detail {
            .label {
              margin-bottom: 13px;
              font-size: 14px;
              color: #888888;
            }

            .value {
              font-weight: bold;
              font-size: 16px;
              color: #363636;
            }
          }
        }

        .location {

          border-bottom: 1px solid #e5e5e5;
        }

        .contact_methods {
          display: flex;
          align-items: center;

          .info_item {
            flex: 1;

            .tag {
              margin-right: 8px;
              width: 1px;
              height: 48px;
              background: #E5E5E5;
            }
          }
        }
      }

      .map-card:hover {
        transform: scale(1.01);
      }

      .title_mobile{
        display: none;
      }
    }
  }

  .mini {
    height: 262px !important;
  }

  .section {
    .section-container {
      max-width: 1400px;
      min-width: 1400px;
      margin: 0 auto;
      padding: 0 40px;
    }
  }

  .navigation {
    font-weight: 400;
    font-size: 12px;
    color: #C2C2C2;
    line-height: 64px;
    margin-bottom: 36px;
  }

  .maps-section {
    display: grid;
    grid-template-rows: 1fr 1fr;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    margin-bottom: 125px !important;
    .map-card-mobile{
      display: none;
    }
    .map-card {
      line-height: 1;
      bottom: 150px;
      box-sizing: border-box;
      width: 690px;
      height: 335px;
      padding: 50px 60px;
      background: #F9FAFC;
      border-radius: 10px;

      h2 {
        margin-bottom: 32px;
        font-weight: 600;
        font-size: 40px;
        color: #363636;
      }

      .light_line {
        position: relative;

        .line {
          width: 100%;
          height: 1px;
          background: #e5e5e5;
        }

        .light {
          position: absolute;
          left: 0;
          top: 0;
          width: 24px;
          height: 3px;
          background: #0248FF;
        }
      }

      .info_item {
        display: flex;
        align-items: flex-start;
        padding: 34px 0 0;

        img {
          margin-right: 17px;
        }

        .detail {
          .label {
            margin-bottom: 13px;
            font-size: 14px;
            color: #888888;
          }

          .value {
            font-weight: bold;
            font-size: 16px;
            color: #363636;
          }
        }
      }


      .contact_methods {
        display: flex;
        align-items: center;

        .info_item {
          flex: 1;

          .tag {
            margin-right: 8px;
            width: 1px;
            height: 48px;
            background: #E5E5E5;
          }
        }
      }
    }

    .map-card:hover {
      background-color: #ECF1FF;
    }
  }
}

// mobile
@media (max-width: 750px) {
  .hero {
    height: 229px;
    background: url('../static/contact/head_bg_mobile.png') center/cover no-repeat;
    // background-size: 100% 100%;

    .hero-overlay {
      padding-top: 55px!important;
      .map-card {
        display: none!important;
        position: relative;
        line-height: 1;
        top: 232px;
        bottom: 150px;
        box-sizing: border-box;
        width: 686px;
        height: 418px;
        padding: 70px 60px 36px;
        background: #fff;

        h2 {
          margin-bottom: 42px;
          font-weight: 600;
          font-size: 40px;
          color: #363636;
        }

        .light_line {
          position: relative;

          .line {
            width: 100%;
            height: 1px;
            background: #e5e5e5;
          }

          .light {
            position: absolute;
            left: 0;
            top: 0;
            width: 24px;
            height: 3px;
            background: #0248FF;
          }
        }

        .info_item {
          display: flex;
          align-items: flex-start;
          padding: 34px 0;

          img {
            margin-right: 17px;
          }

          .detail {
            .label {
              margin-bottom: 13px;
              font-size: 14px;
              color: #888888;
            }

            .value {
              font-weight: bold;
              font-size: 16px;
              color: #363636;
            }
          }
        }

        .location {

          border-bottom: 1px solid #e5e5e5;
        }

        .contact_methods {
          display: flex;
          align-items: center;

          .info_item {
            flex: 1;

            .tag {
              margin-right: 8px;
              width: 1px;
              height: 48px;
              background: #E5E5E5;
            }
          }
        }
      }
      .title_mobile{
        line-height: 174px;
        text-align: center;
        font-size: 24px;
        color: #ffffff;
      }
    }
  }

  .mini {
    height: 198px !important;
  }

  .section {
    .section-container {
      padding: 0 24px;
    }
  }

  .navigation {
    font-weight: 400;
    font-size: 12px;
    color: #C2C2C2;
    line-height: 64px;
    margin-bottom: 36px;
  }

  .maps-section {
   display: flex;
   flex-direction: column;
    gap: 10px;
    margin-bottom: 50px !important;

    .map-card-mobile{
     height: 265px!important;
      background: #ECF1FF!important;
    }

    .map-card {
      line-height: 1;
      bottom: 150px;
      box-sizing: border-box;
      width: 100%;
      height: 250px;
      padding: 25px 20px;
      background: #F9FAFC;
      border-radius: 5px;

      h2 {
        margin-bottom: 16px;
        font-weight: 600;
        font-size: 20px;
        color: #363636;
      }

      .light_line {
        position: relative;

        .line {
          width: 100%;
          height: 1px;
          background: #e5e5e5;
        }

        .light {
          position: absolute;
          left: 0;
          top: 0;
          width: 12px;
          height: 2 px;
          background: #0248FF;
        }
      }

      .info_item {
        display: flex;
        align-items: flex-start;
        padding: 17px 0 0;

        img {
          margin-right: 10px;
        }

        .detail {
          .label {
            margin-bottom: 13px;
            font-size: 12px;
            color: #888888;
          }

          .value {
            font-weight: bold;
            font-size: 12px;
            color: #363636;
          }
        }
      }


      .contact_methods {
        display: flex;
        flex-direction: column;
        // align-items: center;

        .info_item {
          flex: 1;

          .tag {
            display: none;
            margin-right: 8px;
            width: 1px;
            height: 48px;
            background: #E5E5E5;
          }
        }
      }
    }
  }
}
</style>
